<template>
    <div class="wapper">
        <div class="query-wapper">
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-input placeholder="发票信息编号" v-model="query.invoiceInfoCode"></el-input>
                </el-col>
                <el-col :span="6">
                    <el-input placeholder="发票抬头" v-model="query.invoiceTitle"></el-input>
                </el-col>


                <el-col :span="6">

                    <el-select placeholder="请选择合约公司" v-model="query.companyId">
                        <el-option v-for="item in getContractCompanyData" :key="item.id" :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>

                </el-col>

                <el-col :span="6">
                    <Select :type="'InvoiceInfoStateEnum'" :placeholder="'发票状态'" @change="change"></Select>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-input placeholder="关联申请编号" v-model="query.invoiceApplyCode"></el-input>

                </el-col>
                <el-col :span="6">
                    <Select :type="'InvoiceTypeNewEnum'" :placeholder="'开票类型'" @change="change"></Select>
                </el-col>
                <el-col :span="6">
                    <el-date-picker v-model="createTime" type="datetimerange" range-separator="至"
                        start-placeholder="审核完成开始日期" end-placeholder="审核完成结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                        @change="pickerChangeFn()" style="width:100%">
                    </el-date-picker>
                </el-col>
                <el-col :span="6">
                    <el-input placeholder="申请人" v-model="query.applyUserName"></el-input>
                </el-col>
            </el-row>
            <div class="button-wapper">
                <el-button plain size='mini' v-auth="'view'" @click="getInfoList(undefined)">查询</el-button>
                <el-button plain size='mini' @click="reset">重置</el-button>
                <el-button plain v-auth="'export'" size='mini' @click="exportInvoice" type="primary">批量导出</el-button>
                <el-button plain v-auth="'bill'" size='mini' @click="batchInvoice" type="primary">批量开票</el-button>
            </div>
        </div>
        <div class="content-wapper">
            <el-table :data="infos" size='mini' :border="true">
                <el-table-column prop="invoiceInfoCode" width="150" label="发票信息编号"></el-table-column>
                <el-table-column prop="invoiceApplyCode" width="150" label="关联申请编号"></el-table-column>
                <el-table-column prop="customerInvoiceName" width="150" label="发票抬头"></el-table-column>
                <el-table-column prop="companyName" width="250" label="合约开票公司"></el-table-column>
                <el-table-column prop="totalInvoice" label="发票总额">
                    <template slot-scope="scope">
                        {{ scope.row.totalInvoice / 100 }}
                    </template>
                </el-table-column>
                <el-table-column prop="stateName" label="发票状态"></el-table-column>
                <el-table-column prop="drawerName" label="开票人"></el-table-column>
                <el-table-column prop="ownerUserName" label="申请人"></el-table-column>
                <el-table-column prop="region" label="所属区域"></el-table-column>
                <el-table-column prop="gmtCreate" width="200" label="申请时间"></el-table-column>
                <el-table-column label="操作" width="350" fixed="right">
                    <template slot-scope="scope">
                        <el-button @click="getDetail(scope.row)" type="text" v-auth="'view'" size="small">查看</el-button>

                        <el-button @click="confirmInvoice(scope.row)" type="text" v-auth="'invoicing'"
                            v-if="scope.row.state == 1" size="small">立即开票</el-button>
                        <!-- <el-button @click="cancel(scope.row)"
                         type="text"
                         v-if="scope.row.state==4 || scope.row.state==5 || scope.row.state==7 "
                         size="small">作废发票</el-button> -->
                        <el-button @click="editInvoice(scope.row)" type="text" v-if="scope.row.state == 2"
                            size="small">修改发票号码</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <br>
            <el-pagination :current-page.sync="query.pageIndex" :page-size="query.pageSize"
                @current-change="handleCurrentChange" class="pagation" layout="prev, pager, next, jumper"
                :total="query.total">
            </el-pagination>
        </div>
        <!-- 添加合约公司 -->
        <addInvoiceCompany ref="addInvoiceCompany" @refresh="getInfoList"></addInvoiceCompany>
        <el-dialog title="立即开票" :visible.sync="dialogVisible" width="60%">
            <el-table :data="tableData">
                <el-table-column prop="invoiceInfoCode" label="开票信息编号">
                </el-table-column>
                <el-table-column prop="companyName" label="开票公司">
                </el-table-column>
                <el-table-column prop="invoiceTypeName" label="发票类型">
                </el-table-column>
                <el-table-column prop="totalInvoice" label="开票总金额">
                </el-table-column>
                <el-table-column prop="drawerName" label="开票人">
                </el-table-column>
                <el-table-column label="发票编号">
                    <template slot-scope="scope">
                        <el-input onkeyup="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'')"
                            v-model="scope.row.invoiceCode"></el-input>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
        <!-- <el-dialog title="作废发票"
                 :visible.sync="cancelDialogVisible"
                 width="40%">
        <span>提交后已开发票信息将作废，已开发票金额将回滚至原始订单的剩余可开票金额中，是否确认作废？</span>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="cancelDialogVisible = false">取 消</el-button>
          <el-button type="primary"
                     @click="cancelSubmit">确定作废</el-button>
        </span>
      </el-dialog> -->

        <el-dialog title="修改发票号码" :visible.sync="editDialogVisible" width="40%">
            <el-form label-width="180px">
                <el-form-item label="现已开票的发票号码：">
                    {{ invoiceCode }}
                </el-form-item>
                <el-form-item label="发票号码修改为：">
                    <el-input v-model.trim="editInvoiceData.newInvoiceCode" type="text"
                        @change="editInvoiceChange($event, editInvoiceData)" placeholder="请输入确定的发票号码"></el-input>
                        <div class="tips" style="color: #b2b2b2;">注:只能输入数字</div>
                </el-form-item>
                
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="editInvoiceSubmit">确认修改</el-button>
            </span>
        </el-dialog>
        <!-- 立即开票弹窗 -->
        <el-dialog title="开票信息" :visible.sync="singleDialogVisible" width="40%">
            <el-form label-width="180px">
                <el-form-item label="发票号码：">
                    <el-input type="text" v-model.trim="singleSubmitData.invoiceCode" placeholder="请输入确定的发票号码"
                        @change="invoiceCodeChange($event, singleSubmitData)"></el-input>
                        <div class="tips" style="color: #b2b2b2;">注:只能输入数字</div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="singleDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="singleSubmit">确认开票</el-button>
            </span>
        </el-dialog>
        <!-- 批量导入发票号码弹窗 -->
        <el-dialog title="批量导入发票号码" destroy-on-close :visible.sync="dialogCode" width="50%">
            <div class="info">
                <span>温馨提醒</span>
                <span>1、上传导入文件必须是 .xls或 .xlsx格式</span>
                <span>2、请严格按照导入模板格式处理数据，确保上传的文档中无空格等特殊字符；</span>
            </div>
            <div class="one">
                <span>Step1：下载文档模板，按照要求处理数据</span>
                <el-button @click="getDetailFun()" size="small">下载模板</el-button>
            </div>
            <div class="two">
                <span>Step2：导入处理好的数据文档</span>
                <input @change="fileChange($event)" type="file"
                    accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                <!-- <Upload :tipInfo="tipInfo"
                            @onSuccess="onSuccess"
                            :limit="1"
                            :listType="'text'"></Upload> -->
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogCode = false">取 消</el-button>
                <el-button type="primary" @click="submitImport()">确认导入</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
import _tax from '@/service/tax-service'
import Select from '@/views/common/Select'
import _invoiceCompany from '@/service/invoice-company-service'
import _constant from '@/utils/constant'
import addInvoiceCompany from '@/views/invoice/company/add-invoice-company'
export default {
    components: {
        addInvoiceCompany,
        Select
    },

    data() {
        return {
            selectDate: '',
            getContractCompanyData: null,
            form: {
                name: '',
            },
            editDialogVisible: false,
            cancelDialogVisible: false,
            dialogVisible: false,
            singleDialogVisible: false,
            dialogCode: false,
            invoiceId: null,
            tableData: null,
            infos: null,
            states: null,
            createTime: [],
            query: {
                invoiceInfoCode: '',
                invoiceApplyCode: '',
                invoiceTitle: '',
                invoiceType: '',
                companyId: '',
                invoiceState: '',
                startTime: '',
                endTime: '',
                applyUserName: '',
                pageIndex: 1,
                pageSize: 20,
                total: 0,


            },
            singleSubmitData: {
                id: null,
                invoiceCode: null
            },
            editInvoiceData: {
                id: null,
                newInvoiceCode: null
            },
            invoiceCode: null,
            file: null,
            list: []
        }
    },
    mounted() {
        this.getInfoList()
        this.getContractCompanyList()
        // 状态
        this.states = _constant.states
    },
    methods: {
        invoiceCodeChange(e, row) {
            if (e) {
                let reg = /^\d{1,32}$/
                if (reg.test(e)) {
                    this.$set(row, 'invoiceCode', e)
                }

            } 
        },
        editInvoiceChange(e, row) {
            if (e) {

                let reg = /^\d{1,32}$/
                if (reg.test(e)) {
                    this.$set(row, 'newInvoiceCode', e)
                } 
            }
        },
        pickerChangeFn() {
            if (!this.createTime) {
                this.createTime = []
            }
        },
        //合约公司
        getContractCompanyList() {
            _tax.getContractCompany('', response => {
                this.getContractCompanyData = response
            }, response => {
                root.$notify({
                    message: response,
                    type: 'warning'
                })
            })
        },
        //修改发票号
        editInvoice(row) {
            this.editInvoiceData.newInvoiceCode = null
            this.editDialogVisible = true
            this.invoiceCode = row.invoiceCode
            this.editInvoiceData.id = row.id
        },
        editInvoiceSubmit() {

            if (this.editInvoiceData.newInvoiceCode == null) {
                this.$notify({
                    message: '发票号码不能为空',
                    type: 'warning'
                })
                return false
            }
            let reg = /^\d{1,32}$/
            if (!reg.test(this.editInvoiceData.newInvoiceCode)) {
                this.$notify({
                    message: '发票号码不正确',
                    type: 'warning'
                })
                return false
            }
            _tax.updateInvoiceCode(
                this.editInvoiceData,
                (response) => {
                    this.editDialogVisible = false
                    this.getInfoList()

                }, response => {
                    this.$notify({
                        message: response,
                        type: 'warning'
                    })
                })
        },
        batchInvoice() {
            this.dialogCode = true
        },
        fileChange(e) {
            this.file = e.target.files[0]
            let _loading = this.$loading({ fullscreen: true })
            _tax.batchOpenInvoiceUpload(
                this.file,
                (response) => {
                    _loading.close()
                    this.$notify({
                        message: '上传成功',
                        type: 'warning'
                    })

                    this.list = response
                    console.log(response);
                }, response => {
                    _loading.close()
                    this.$notify({
                        message: response,
                        type: 'warning'
                    })
                })
        },
        submitImport() {

            let _loading = this.$loading({ fullscreen: true })
            var data = {
                list: this.list
            }
            _tax.updateBatchOpenInvoice(
                data,
                (response) => {
                    _loading.close()
                    this.$notify({
                        message: '导入成功',
                        type: 'warning'
                    })
                    this.dialogCode = false
                    this.getInfoList()

                }, response => {
                    _loading.close()
                    this.$notify({
                        message: response,
                        type: 'warning'
                    })
                })
        },
        getDetailFun() {
            location.href = 'https://rs.juyoufuli.com/static/excel/%E6%89%B9%E9%87%8F%E5%BC%80%E7%A5%A8%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'

        },
        // cancelSubmit () {
        //   _tax.cancelInvoiceData(
        //     { id: this.invoiceId },
        //     (response) => {
        //       this.getInfoList()
        //       this.cancelDialogVisible = false

        //     }, response => {
        //       this.$notify({
        //         message: response,
        //         type: 'warning'
        //       })
        //     })
        // },
        //作废发票
        // cancel (row) {
        //   this.invoiceId = row.id
        //   this.cancelDialogVisible = true
        // },
        //导出
        exportInvoice() {

            if (!this.createTime || this.createTime.length == 0) {
                this.$message({
                    message: '请选择时间范围'
                });
                return false
            }
            this.query.startTime = this.createTime[0]
            this.query.endTime = this.createTime[1]
            _tax.invoiceInfoExport(
                this.query,
                () => { },
                response => {
                    this.$notify({
                        message: response,
                        type: 'warning'
                    });
                })
        },

        submit() {
            let query = []
            this.tableData.forEach(item => {
                query.push({
                    id: item.id,
                    invoiceCode: item.invoiceCode
                })


            })

            _tax.confirmInvoice(
                query,
                (response) => {
                    this.getInfoList()
                    this.dialogVisible = false

                }, response => {
                    this.$notify({
                        message: response,
                        type: 'warning'
                    })
                })

        },
        confirmInvoice(row) {
            this.singleDialogVisible = true
            this.singleSubmitData.id = row.id
        },
        singleSubmit() {
           
            if (this.singleSubmitData.invoiceCode == null) {
                this.$notify({
                    message: '发票号码不能为空',
                    type: 'warning'
                })
                return false
            }
            let reg = /^\d{1,32}$/
            if (!reg.test(this.singleSubmitData.invoiceCode)) {
                this.$notify({
                    message: '发票号码不正确',
                    type: 'warning'
                })
                return false
            }
        

            _tax.updateSolaOpenInvoice(
                this.singleSubmitData,
                (response) => {

                    this.singleDialogVisible = false
                    this.$router.go(0)
                }, response => {
                    this.$notify({
                        message: response,
                        type: 'warning'
                    })
                })

        },
        change(val, label, type) {
            if (type == 'InvoiceInfoStateEnum') {
                this.query.invoiceState = val
            }
            if (type == 'InvoiceTypeNewEnum') {
                this.query.invoiceType = val
            }
        },
        getInfoList(pageIndex) {
            // if (this.query.orderNo) {
            //   if (!this.query.orderType) {
            //     this.$message({
            //       message: '请选择订单类型'
            //     });
            //     return false
            //   }
            // }
            if (pageIndex)
                this.query.pageIndex = pageIndex
            else
                this.query.pageIndex = 1
            this.query.startTime = this.createTime[0]
            this.query.endTime = this.createTime[1]
            _tax.getListInfoPage(
                this.query,
                (response, total) => {
                    // 请求成功
                    this.infos = response
                    // this.infos.forEach((item, index) => {
                    //   this.infos[index].totalApplyInvoice = this.$numberUtils.divide(Number(item.totalApplyInvoice), 100)

                    // })
                    this.query.total = total
                })
        },
        handleCurrentChange(pageIndex) {
            this.getInfoList(pageIndex)
        },
        add() {
            this.$router.push({
                path: '/invoice-manage-add'
            })
        },
        getDetail(row) {
            this.$saveParams(this.query)
            this.$router.push({
                path: '/invoice-infomanage-detail?id=' + row.id
            })
        },
        edit(row) {
            this.$saveParams(this.query)
            this.$router.push({
                path: '/invoice-manage-add',
                query: {
                    id: row.id
                }
            })
            // this.$refs.addInvoiceCompany.show(row.id)
        },
        reset() {
            location.reload()

        },
        updateContractCompanyState(rows) {
            _invoiceCompany.updateContractCompanyState(rows.id, rows.state, () => {
                this.$notify({
                    message: '修改成功',
                    type: 'success'
                });
            })
        }
    }
}
</script>
  
<style scoped>
.wapper /deep/ .el-date-editor .el-range-input,
.el-date-editor .el-range-separator {
    font-size: 12px;
}

.wapper /deep/.el-date-editor .el-range-input {
    width: 71%;
}

.wapper {
    padding: 15px;
}

.header {
    margin-bottom: 15px;
}

.query-wapper {
    margin: 15px;
    padding: 15px;
    border: 1px solid #d6dbe5;
    position: relative;
    background: #fff;
}

.query-wapper::after {
    position: absolute;
    content: "筛选条件";
    top: -9px;
    color: #909399;
    background-color: #fbfbfb;
}

.content-wapper {
    padding: 0 15px;
    padding-bottom: 30px;
}

.button-wapper {
    margin-top: 10px;
}

.el-row {
    margin-bottom: 15px;
}

.info {
    display: flex;
    padding-bottom: 15px;
    border-bottom: 1px solid rgb(226, 226, 226);
    flex-direction: column;
}

.info span {
    margin-top: 0;
    color: #ff5e5e;
}

.info {
    background-color: #f8eec0;
    padding: 15px;
}

.info span:first-child {
    font-weight: bold;
    margin-bottom: 15px;
}

.one {
    font-weight: bold;
    margin-top: 20px;
}

.one span {
    margin-right: 20px;
}

.two {
    display: flex;
    align-items: center;
    font-weight: bold;
    margin-top: 20px;
}

.two span:first-child {
    margin-right: 20px;
}
</style>